<!--
 * @Description: 
-->
<template>
  <el-form :inline="true" :model="filters" :size="size">
    <el-form-item>
      <el-input
        prefix-icon="el-icon-search"
        v-model="filters.lecturerName"
        placeholder="讲师姓名"
      ></el-input>
    </el-form-item>
    <el-form-item>
      <butn btntype="primary" :title="'查询'" @click.native="initData"></butn>
      <butn :title="'重置'" @click.native="resetData" class="czButn"></butn>
    </el-form-item>
  </el-form>
</template>

<script>
import butn from "@/components/button/index";
export default {
  components: {
    butn,
  },
  data() {
    return {
      filters: {},
      onlineList: [],
      topList: [],
      size: "small",
    };
  },
  created() {},
  methods: {
    initData() {
      this.$emit("search", { ...this.filters, t: new Date().getTime() });
    },
    resetData() {
      this.filters = {};
      this.$emit("search", { t: new Date().getTime() });
    },
  },
};
</script>
